import { FormWrapper } from 'components/form/styles';
import { Column, Section } from 'components/grid/wrappers/FlexWrapper';
import { pinCodeLength } from 'components/modals/CreateWalletPinModal/constants';
import { Button } from 'components/ui/buttons/Button';
import { CodeInput } from 'components/ui/inputs/CodeInput';
import { Text } from 'components/ui/typography/Text';
import { useField } from 'formik';
import React, { FC, FormEvent } from 'react';
import { walletEffects } from 'stores/wallet';
import { NoopType } from 'types';

interface Props {
    onSuccess?: NoopType;
    onError?: NoopType;
}

export const Form: FC<Props> = ({ onSuccess, onError }) => {
    const [, { value, error, touched }, { setValue, setTouched }] = useField<string>('code');

    const handleChange = (value: string) => {
        !touched && value.length === pinCodeLength && setTouched(true);
        setValue(value);
    };

    const handleFormSubmit = async (e: FormEvent) => {
        e.preventDefault();

        if (!!error || !value) {
            return;
        }

        try {
            await walletEffects.getWalletTokenFx(value);
            onSuccess?.();
        } catch {
            onError?.();
        }
    };

    return (
        <FormWrapper onSubmit={handleFormSubmit}>
            <Section marginBottom="28px">
                <CodeInput
                    count={pinCodeLength}
                    error={touched && error ? error : ''}
                    value={value}
                    onChange={handleChange}
                />
            </Section>

            <Column noWrap marginBottom="24px" width="100%">
                <Section justifyCenter marginBottom="12px">
                    <Text alignTextCenter isBold>
                        Please enter your wallet pin
                    </Text>
                </Section>
                <Section justifyCenter>
                    <Text alignTextCenter size="-2">
                        Please enter the pin for your BULLZ wallet. This is to ensure wallet security and a safe BULLZ
                        environment.
                    </Text>
                </Section>
            </Column>

            <Section>
                <Button wide disabled={!touched || !!error} type="submit">
                    Next
                </Button>
            </Section>
        </FormWrapper>
    );
};
